import { axiosRequest, type AxiosResult } from "@/lib/axios";
import type { FormPage } from "../types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export interface FormPageUpdateRequest {
	status?: "enabled" | "disabled";
}

export const formPageApi = {
	update: (workspaceId: string, formId: string, formPageId: string, payload: FormPageUpdateRequest): Promise<AxiosResult<FormPage>> => {
		return axiosRequest({
			method: "PATCH",
			url: `${API_BASE_URL}/${workspaceId}/forms/${formId}/pages/${formPageId}`,
			data: payload,
		});
	},
};
